import { render, staticRenderFns } from "./DossiersPrevisionnels.vue?vue&type=template&id=d3821876&scoped=true&"
import script from "./DossiersPrevisionnels.vue?vue&type=script&lang=js&"
export * from "./DossiersPrevisionnels.vue?vue&type=script&lang=js&"
import style0 from "./DossiersPrevisionnels.vue?vue&type=style&index=0&id=d3821876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3821876",
  null
  
)

export default component.exports